import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { ProductTypeWithIdAndPrice } from '@/types';
import { t } from '@/utils/i18n';
import { getParams } from '@/utils/params';
import { selectRatings } from '@/redux/productTypes/getters/selectRatings';
import { Rating } from './Rating';
import './ProductTypeRatings.scss';

interface Props {
  productType: ProductTypeWithIdAndPrice;
  className?: string;
}

export const ProductTypeRating: FunctionComponent<Props> = ({ productType, className }) => {
  const ratings = useSelector(selectRatings);
  const ptRating = ratings[productType.id];

  if (!ptRating || ptRating.count === 0 || ptRating.rating === 0) {
    return null;
  }

  const jumpToReviews = () => {
    const jumpToReviews = getParams().jumpToReviews;
    if (jumpToReviews) {
      jumpToReviews();
    }
  };

  return (
    <button
      className={cn('product-type-ratings', className)}
      title={t('rating.label', String(ptRating.rating), String(ptRating.count))}
      onClick={jumpToReviews}
    >
      <Rating maxRating={5} rating={ptRating.rating} />
      <span className="product-type-ratings__count">({ptRating.count})</span>
    </button>
  );
};
